import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15a759af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "partners" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-line" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode(" Meet Our "),
    /*#__PURE__*/_createElementVNode("span", { class: "color" }, "Partners")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "title-text" }, " We work with some of the largest providers in the gaming industry! ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "partner-list" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (logo) => {
          return (_openBlock(), _createElementBlock("div", {
            key: logo,
            class: "partner-holder"
          }, [
            _createElementVNode("img", {
              src: require(`@/assets/img/partners/${logo}`)
            }, null, 8, _hoisted_6)
          ]))
        }), 128))
      ])
    ])
  ]))
}